import { FAN_MODE } from '../../../server/utils/constants';

// A fan whose highest mode is LOW has no speeds: it is on or off. An integration says so by
// declaring `max` as FAN_MODE.LOW, which is also what the HomeKit bridge restores when such a fan
// is switched on, so the same feature works there and here without anything new on the server.
export function isOnOffFan(deviceFeature) {
  if (!deviceFeature || deviceFeature.max === undefined || deviceFeature.max === null) {
    return false;
  }
  return Number(deviceFeature.max) <= FAN_MODE.LOW;
}

// The modes a fan can actually take. A feature without a max offers all of them, as before.
export function fanModesFor(deviceFeature) {
  const modes = Object.values(FAN_MODE);
  if (!deviceFeature || deviceFeature.max === undefined || deviceFeature.max === null) {
    return modes;
  }
  return modes.filter(mode => mode <= Number(deviceFeature.max));
}

// "Low" means nothing on a fan with one speed, so an on/off fan's modes read Off and On.
export function fanModeLabelKey(deviceFeature, mode) {
  return isOnOffFan(deviceFeature)
    ? `deviceFeatureValue.category.fan.onOff.${mode}`
    : `deviceFeatureValue.category.fan.mode.${mode}`;
}
